import BaseCadastro from "components/BaseCadastro";
import Deposito from "model/suprimentos/Deposito";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DepositoService from "service/suprimentos/DepositoService";
import "react-hook-form";
import {Controller, useForm} from "react-hook-form";
import { Label } from "components/input/Label";

const depositoService = new DepositoService();

export default function DepositoCadastro() {

    const [queryParameters] = useSearchParams();

    const {control, clearErrors, setError, setFocus, register, formState: {errors}} = useForm();

    const [deposito, setDeposito] = useState<Deposito>(new Deposito());
    const [titulo, setTitulo] = useState<string>('Depósito');
    const [editando, setEditando] = useState<boolean>(false);

    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }
    },[])

    function validar() {

        if (!deposito.codigo) {
            setError("codigo", {type: "manual", message: "Código é Obrigatório"}, {shouldFocus: true})
            return false;
        } if (!deposito.nome) {
            setError("nome", {type: "manual", message: "Nome é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={deposito} service={depositoService} novoCadastro
            getNewModel={()=> new Deposito()} setModel={(value: Deposito) => setDeposito(value)} validar={() => validar()} urlService="/deposito" pathCadastro="/deposito" tituloPagina={'Deposito'}>

            {titulo ?
                <div className="row" style={{ marginBottom: 10 }}>
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={deposito.ativo}
                    onChange={(e) => setDeposito({ ...deposito, ativo: e.target.checked as boolean })}
                    style={{ marginRight: 5 }} />
                <label>Ativo</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText 
                        disabled={editando} 
                        className={errors.codigo ? "p-invalid" : ""}
                        required value={deposito.codigo || ""} 
                        style={{ width: '100%' }} 
                        {...register("codigo", {
                            onChange: (e) => {
                                setDeposito({ ...deposito, codigo: e.target.value })
                                clearErrors("codigo")
                            } 
                        })}
                    />
                </div>
                {errors.codigo && errors.codigo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText 
                        required value={deposito.nome} 
                        className={errors.nome ? "p-invalid" : ""}                         
                        style={{ width: '100%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setDeposito({ ...deposito, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>


        </BaseCadastro>
    )
}
